import { useGetFaireAcademyPageState } from "@faire/retailer-visitor-shared/hooks/openWithFaire/useGetFaireAcademyPageState";
import { AcademyGuideCardLarge } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/components/GuideCards/AcademyGuideCardLarge";
import { AcademyGuideCardSmall } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/components/GuideCards/AcademyGuideCardSmall";
import { useGetNextGuide } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guidePages/components/useGetNextOrOtherGuides";
import { GuideColumnSection } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guidePages/styles";
import {
  FaireAcademyGuide,
  OWF_GUIDE_SOURCE_NAME,
} from "@faire/retailer-visitor-shared/views/open-with-faire/academy/types";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackOpenWithFaireIndividualGuideCtaClick } from "@faire/web-api--source/events/openWithFaire/click/individualGuideCta";
import { trackOpenWithFaireLargeGuideCardCtaClick } from "@faire/web-api--source/events/openWithFaire/click/largeGuideCardCta";
import * as React from "react";

export const JumpToTheNextGuide: React.FC<{
  currentGuide: FaireAcademyGuide;
}> = ({ currentGuide }) => {
  const { isMobile } = useViewport();
  const { pageState } = useGetFaireAcademyPageState();
  const guide = useGetNextGuide(currentGuide);
  if (!guide) {
    return null;
  }
  return (
    <>
      <Spacer height={{ mobileAndAbove: "3x", tabletAndAbove: "8x" }} />
      <GuideColumnSection gap="4x">
        <Typography variant="displaySSerifRegular">
          <StrictLocalMsg
            defaultMessage="Jump to the next guide"
            description={{
              text: "Title for section prompting retailer to continue to next Faire Academy guide",
              img: "https://cdn.faire.com/fastly/6a6daf08c937daadaaa188113b7e1f74420cc7ddb977117d145b3fed31680c04.png",
            }}
          />
        </Typography>
        {isMobile ? (
          <AcademyGuideCardSmall
            fullWidth
            guide={guide}
            onClick={() =>
              trackOpenWithFaireIndividualGuideCtaClick(
                pageState,
                currentGuide.title,
                OWF_GUIDE_SOURCE_NAME.INDIVIDUAL_GUIDE_PAGE,
                guide.title
              )
            }
          />
        ) : (
          <AcademyGuideCardLarge
            guide={guide}
            onClick={() =>
              trackOpenWithFaireLargeGuideCardCtaClick(
                pageState,
                currentGuide.title,
                OWF_GUIDE_SOURCE_NAME.INDIVIDUAL_GUIDE_PAGE,
                guide.title
              )
            }
          />
        )}
      </GuideColumnSection>
    </>
  );
};
